import {
  cilApplicationsSettings,

  // used in oceanbolt
  cilHome,
  cilGlobeAlt,
  cilMap,
  cilLayers,
  cilBrushAlt,
  cilChart,
  cilUser,
  cilAccountLogout,
  cilBoatAlt,
  cilSpeedometer,
  cilNotes,
  cilSwapHorizontal,
  cilChartLine,
  cilColumns,
  cilGrid,
  cilChevronDoubleUp,
  cilSchool,
} from '@coreui/icons'

export const iconsSet = Object.assign({}, {
  cilApplicationsSettings,

  // used in oceanbolt
  cilHome,
  cilGlobeAlt,
  cilMap,
  cilLayers,
  cilBrushAlt,
  cilChart,
  cilUser,
  cilAccountLogout,
  cilBoatAlt,
  cilSpeedometer,
  cilNotes,
  cilChartLine,
  cilSwapHorizontal,
  cilColumns,
  cilGrid,
  cilChevronDoubleUp,
  cilSchool,

});
